/* eslint-disable eqeqeq */
import React, { useRef, useState } from 'react';
import { LoadingAlert } from '@/pages/manage/common';
import ManageBar from '@/components/manageBar';
import ManageContainer from '../components/manageContainer';
import { MemberCard, MemberColCard } from '../components/memberCard';
import {
  ControlWrapper,
  StartButton,
  PlatRecord,
PlatLive,
  DoubleContent,
  AutoSpeak,
  PlusTimeModal,
  TimeClock,
  LocalRecord,
  RollCall,
  RestartButton,
} from '../components/controlCard';
import './index.scss';

const Interact = (props) => {
  const {
    match: {
      params: { id },
    },
  } = props;

  const propsRef = useRef();

  const [visible, setVisible] = useState(false);

  const [timeCurrent, setTimeCurrect] = useState(undefined);

  return (
    <ManageBar title="互动管控">
      <ManageContainer id={id}>
        {(props) => {
          const { detail, status, buttons, members, speaks, socket } = props;
          propsRef.current = props;
          return (
            <div className="interact">
              <div className="top-wrapper">
                <div className="elem-text">
                  <div>
                    <label>课程名称:</label>
                    <span>{detail.name || '无'}</span>
                  </div>
                  <div>
                    <label>主讲老师:</label>
                    <span>{detail.teachInfo && (detail.teachInfo.lecturerName || '无')}</span>
                  </div>
                  <div>
                    <label>教室:</label>
                    <span>{detail.memberName || '无'}</span>
                  </div>
                </div>
                <div className="elem-time">
                  <TimeClock
                    value={status.duration}
                    endTime={status.endTime}
                    startTime={status.startTime}
                    onChange={setTimeCurrect}
                    onClick={() => {
                      // if(status.conferenceStatus === '1')
                      setVisible(true);
                    }}
                  ></TimeClock>
                </div>
                <div className="elem-button-wrapper">
                  <StartButton
                    status={status.conferenceStatus || detail.conferenceStatus}
                    handleStart={() => {
                      LoadingAlert('加载中...');
                      propsRef.current.socket.startConference();
                    }}
                    handleEnd={() => {
                      LoadingAlert('加载中...');
                      propsRef.current.socket.endConference();
                    }}
                  ></StartButton>
                  {status.conferenceStatus == '1' ? (
                    <RestartButton id={id} socket={socket} />
                  ) : null}
                </div>
              </div>
              <div className="elem-message">
                <div className="elem-message-left">
                  <span className="elem-message-left-class-number">
                    参与教室（{status.memberNumber}）
                  </span>
                  <span>在线（{status.onlineNumber}）</span>
                  <span>未在线（{status.memberNumber - status.onlineNumber}）</span>
                </div>
                <div className="elem-message-right">
                  <span>当前发言列表</span>
                </div>
              </div>
              <div className="conference-member-list">
                <div className="conference-member-list-wrapper">
                  {members.map((item) => (
                    <MemberCard
                      key={item.roomId}
                      roomId={item.roomId}
                      title={item.name}
                      connected={item.connected}
                      audioMute={item.audioMute}
                      speaking={item.speaking}
                      handleSpeak={(params) => propsRef.current.socket.setSpeak(params)}
                      handleConnect={(params) => propsRef.current.socket.setCall(params)}
                      handleDisConnect={(params) => propsRef.current.socket.setHangup(params)}
                      handleMuteAudio={(params) => propsRef.current.socket.setMute(params)}
                    ></MemberCard>
                  ))}
                  {Array.from({ length: members.length % 4 }).map(() => (
                    <div className="member-none"></div>
                  ))}
                </div>
                <div className="conference-member-list-col">
                  {speaks.map((item) => (
                    <MemberColCard
                      key={item.roomId}
                      title={item.name}
                      roomId={item.roomId}
                      handleClick={(params) => propsRef.current.socket.setSpeak(params)}
                    ></MemberColCard>
                  ))}
                </div>
              </div>
              <ControlWrapper id={id} roomId={detail && detail.memberId}>
                <PlatRecord
                  time={status.recordTime}
                  status={buttons.platRecord}
                  handleClick={(params) => propsRef.current.socket.setPlatFormRecord(params)}
                ></PlatRecord>
                <LocalRecord
                  status={buttons.localRecord}
                  handleClick={(params) => propsRef.current.socket.setLocalRecord(params)}
                />
                {/* <RecordStop
                  status={buttons.platRecord}
                  handleClick={(params) => propsRef.current.socket.setPlatFormRecord(params)}
                ></RecordStop> */}
                <PlatLive
                  status={buttons.platLive}
                  handleClick={(params) => {
                    propsRef.current.socket.setPlatFormLive(params);
                    if (params.operation === 'stop') {
                      propsRef.current.socket.setPlatFormRecord(params);
                    }
                  }}
                ></PlatLive>
                <DoubleContent
                  status={buttons.doubleContent}
                  handleClick={(params) => propsRef.current.socket.setDoubleContent(params)}
                ></DoubleContent>
                <RollCall
                  status={buttons.target}
                  handleClick={(params) => propsRef.current.socket.setVirtualRole(params)}
                />
                <AutoSpeak
                  status={buttons.autoSpeak}
                  handleClick={(params) => propsRef.current.socket.setAutoSpeak(params)}
                ></AutoSpeak>
              </ControlWrapper>
              {status.conferenceStatus === '1' && (
                <PlusTimeModal
                  currect={timeCurrent}
                  startTime={status.startTime}
                  endTime={status.endTime}
                  visible={visible}
                  handleClose={() => {
                    setVisible(false);
                  }}
                  handleOk={(minutes) => {
                    propsRef.current.socket.setOverTime({ id, minutes });
                    setVisible(false);
                  }}
                ></PlusTimeModal>
              )}
            </div>
          );
        }}
      </ManageContainer>
    </ManageBar>
  );
};

export default Interact;
